import { Modal } from 'antd';
import { TDeleteNoteModalProps } from '../Notes.types';

const DeleteNoteModal = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}: TDeleteNoteModalProps) => {
  return (
    <Modal
      title="Delete Note"
      open={open}
      onCancel={onClose}
      onOk={onConfirm}
      okText="Delete"
      okButtonProps={{ danger: true, loading: isLoading }}
      confirmLoading={isLoading}
      cancelText="Cancel"
    >
      <p>
        Are you sure you want to delete this note? This action cannot be undone.
      </p>
    </Modal>
  );
};

export default DeleteNoteModal;
